export default {"src":"/_next/static/media/valid-mail-hover.ee5fae1a.svg","height":30,"width":42};